import AppIcon from '../icons/AppIcon'
import styles from './GateScreen.module.css'

interface GateHeaderProps {
  city: string
  detail?: string
}

export default function GateHeader({ city, detail }: GateHeaderProps) {
  return (
    <div className={styles.head}>
      <div className={styles.lockrow}>
        <AppIcon icon="mdi:lock" size={14} />
        Gate reached
      </div>
      <h1 className={styles.headTitle}>{city}</h1>
      <p className={styles.headSub}>
        {detail ?? 'Logging is paused until the whole team clears this challenge.'}
      </p>
    </div>
  )
}
